<template>
  <div class="landing-page">
    <!-- Премиальный экран загрузки (Preloader) -->
    <Preloader @hide="onPreloaderHide" />

    <!-- Шапка / Навигация -->
    <AppHeader />

    <!-- 1. Главный экран (Hero Section - Critical path) -->
    <HeroSection :play-animation="heroAnimated" />

    <!-- 2. Экосистема продукта (Critical path) -->
    <EcosystemSection class="reveal-on-scroll" />

    <!-- 3. Ключевые преимущества (Bento grid) -->
    <AdvantagesSection class="reveal-on-scroll" />

    <!-- 4. Бесшовная интеграция (Marquee - Lazy) -->
    <IntegrationsSection class="reveal-on-scroll" />

    <!-- 5. Панель аналитики OZO.OFFICE (Lazy) -->
    <AnalyticsSection class="reveal-on-scroll" />

    <!-- 6. Наши клиенты (Social proof - Lazy) -->
    <ClientsSection class="reveal-on-scroll" />

    <!-- 7. Прозрачная стоимость (Pricing & ROI Calc - Lazy) -->
    <PricingSection class="reveal-on-scroll" />

    <!-- 8. Финальный призыв к действию (Footer CTA - Lazy) -->
    <CtaSection class="reveal-on-scroll" />

    <!-- Подвал сайта -->
    <AppFooter />
  </div>
</template>

<script>
import Preloader from "@/components/common/Preloader.vue";
import AppHeader from "@/components/layout/AppHeader.vue";
import HeroSection from "@/components/sections/HeroSection.vue";
import EcosystemSection from "@/components/sections/EcosystemSection.vue";
import AdvantagesSection from "@/components/sections/AdvantagesSection.vue";

// Ленивая загрузка секций ниже первого экрана (Задача 3.3: Web Performance)
const IntegrationsSection = () =>
  import(
    /* webpackChunkName: "section-integrations" */ "@/components/sections/IntegrationsSection.vue"
  );
const AnalyticsSection = () =>
  import(
    /* webpackChunkName: "section-analytics" */ "@/components/sections/AnalyticsSection.vue"
  );
const ClientsSection = () =>
  import(
    /* webpackChunkName: "section-clients" */ "@/components/sections/ClientsSection.vue"
  );
const PricingSection = () =>
  import(
    /* webpackChunkName: "section-pricing" */ "@/components/sections/PricingSection.vue"
  );
const CtaSection = () =>
  import(
    /* webpackChunkName: "section-cta" */ "@/components/sections/CtaSection.vue"
  );
const AppFooter = () =>
  import(
    /* webpackChunkName: "layout-footer" */ "@/components/layout/AppFooter.vue"
  );

import { initScrollReveal, initCounters } from "@/plugins/motion";

export default {
  name: "Home",
  components: {
    Preloader,
    AppHeader,
    HeroSection,
    EcosystemSection,
    AdvantagesSection,
    IntegrationsSection,
    AnalyticsSection,
    ClientsSection,
    PricingSection,
    CtaSection,
    AppFooter,
  },
  data() {
    return {
      heroAnimated: false,
    };
  },
  mounted() {
    // Резервный запуск анимации Hero на случай быстрого пропуска прелоадера
    setTimeout(() => {
      this.heroAnimated = true;
      initScrollReveal();
      initCounters();
    }, 2800);
  },
  methods: {
    onPreloaderHide() {
      this.heroAnimated = true;
      this.$nextTick(() => {
        initScrollReveal();
        initCounters();
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/_variables.scss";

.landing-page {
  width: 100%;
  min-height: 100vh;
  font-family: $font-family-base;
  color: $color-text-dark;
  background-color: $color-bg-white;
  scroll-behavior: smooth;
  overflow-x: hidden;
  position: relative;
}
</style>
